<template>
	<div class="portal-container">
		<!-- 背景光晕 -->
		<div class="orb orb-1"></div>
		<div class="orb orb-2"></div>
		<div class="grid-overlay"></div>

		<!-- 主卡片 -->
		<div class="glass-card">
			<!-- 头部：用户信息 -->
			<div class="user-header">
				<div class="avatar-wrapper">
					<div class="avatar">{{ userName.charAt(0).toUpperCase() }}</div>
					<div class="status-dot" :class="{ active: registered }"></div>
				</div>
				<div class="user-meta">
					<h1 class="greeting">
						您好，{{ userName }}
						<span class="role-badge">{{ userRole }}</span>
					</h1>
					<p class="platform-sub">
						<span class="highlight-text">{{ platformName }}</span> · 智慧教育档案
					</p>
				</div>
			</div>

			<!-- 报名状态卡片 -->
			<div class="status-section">
				<div class="status-card" :class="registered ? 'registered' : 'unregistered'">
					<div class="status-icon">{{ registered ? '✓' : '!' }}</div>
					<div class="status-text">
						<span class="status-title">
							{{ registered ? '您已报名成功，拥有进阶学习资格' : '尚未报名，请先完成线上报名' }}
						</span>
						<span class="status-desc">
							{{ registered ? '扫描下方二维码即可查看活动详情' : '扫描下方二维码即可在线报名' }}
						</span>
					</div>
				</div>
			</div>
			<!-- 已报名：显示二维码引导 -->
			<div class="qr-guide">
				<div class="qr-wrapper">
					<div class="scan-frame">
						<img :src="qrCodeSrc" alt="小程序二维码" class="qr-image" />
						<div class="scan-line"></div>
					</div>
					<div class="qr-label">
						<span class="label-icon"></span> 微信扫码 · 小程序体验
					</div>
				</div>
				<p class="guide-tip">
					使用微信扫描上方二维码，在手机上无缝操作<br class="mobile-break" />
					<span class="light-text">升级同步 · 随时随地编程学习</span>
				</p>
			</div>

			<!-- ★★★ 底部：两个跳转按钮并列 ★★★ -->
			<div class="action-area">
				<div class="button-group">
					<a :href="onlineClassUrl" target="_blank" class="btn-primary btn-class">
						线上编程课堂
						<svg class="btn-arrow" viewBox="0 0 24 24" width="18" height="18">
							<path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2"
								stroke-linecap="round" stroke-linejoin="round" fill="none" />
						</svg>
					</a>
					<a :href="contestUrl" target="_blank" class="btn-primary btn-contest">
						竞赛管理
						<svg class="btn-arrow" viewBox="0 0 24 24" width="18" height="18">
							<path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2"
								stroke-linecap="round" stroke-linejoin="round" fill="none" />
						</svg>
					</a>
				</div>
				<p class="btn-sub">选择您的学习之旅</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		HnsmarteduIsReged,
		HnsmarteduRegistration
	} from '../../api/userMG'
	export default {
		name: 'StudentPortal',
		props: {
			userName: {
				type: String,
				default: '未来之星'
			},
			userRole: {
				type: String,
				default: '学生',
				validator: v => ['学生', '老师'].includes(v)
			},
			isRegistered: {
				type: Boolean,
				default: false
			},
			platformName: {
				type: String,
				default: '科教枢'
			},
			onlineClassUrl: {
				type: String,
				default: 'https://www.maijiedu.com/myClass'
			},
			// ★ 竞赛管理链接（新增）
			contestUrl: {
				type: String,
				default: 'https://jingsai.eduz.org.cn/myMatch'
			},
			qrCodeSrc: {
				type: String,
				default: 'https://robotcla-1305194676.cos.ap-nanjing.myqcloud.com/active_qr_code_46.jpg?size=200x200&data=https://example.com'
			},
			registerApi: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				localRegistered: this.isRegistered
			};
		},
		computed: {
			registered() {
				return this.localRegistered;
			}
		},
		watch: {
			isRegistered(newVal) {
				this.localRegistered = newVal;
			}
		},
		created() {
			if (this.$route && this.$route.query) {
				if (this.$route.query.token) {
					HnsmarteduIsReged(this.$route.query.token).then(re => {
						if (re) {
							this.userName = re[1]
							if (re[0] == 1) {
								this.userRole = "教师"
							}
							if (re[2] == 1) {
								this.localRegistered = true
							}
						}
					})
				}
			}
		},
		methods: {}
	};
</script>

<style scoped>
	/* ===== 全局重置 ===== */
	* {
		box-sizing: border-box;
	}

	.portal-container {
		position: relative;
		width: 100%;
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 24px;
		background: #0a0e1a;
		font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
		overflow: hidden;
	}

	/* ===== 光晕背景 ===== */
	.orb {
		position: absolute;
		border-radius: 50%;
		filter: blur(100px);
		opacity: 0.5;
		pointer-events: none;
		animation: floatOrb 15s infinite alternate ease-in-out;
	}

	.orb-1 {
		width: 600px;
		height: 600px;
		top: -20%;
		left: -20%;
		background: radial-gradient(circle, #00d4ff, #090a1f);
	}

	.orb-2 {
		width: 500px;
		height: 500px;
		bottom: -20%;
		right: -20%;
		background: radial-gradient(circle, #7b2ffc, #090a1f);
		animation-delay: -5s;
	}

	.grid-overlay {
		position: absolute;
		inset: 0;
		background-image:
			linear-gradient(rgba(0, 212, 255, 0.03) 1px, transparent 1px),
			linear-gradient(90deg, rgba(0, 212, 255, 0.03) 1px, transparent 1px);
		background-size: 60px 60px;
		pointer-events: none;
	}

	@keyframes floatOrb {
		0% {
			transform: translate(0, 0) scale(1);
		}

		100% {
			transform: translate(80px, 50px) scale(1.2);
		}
	}

	/* ===== 毛玻璃卡片 ===== */
	.glass-card {
		position: relative;
		z-index: 10;
		width: 100%;
		max-width: 520px;
		background: rgba(255, 255, 255, 0.06);
		backdrop-filter: blur(24px) saturate(180%);
		-webkit-backdrop-filter: blur(24px) saturate(180%);
		border-radius: 48px;
		border: 1px solid rgba(255, 255, 255, 0.12);
		box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.1);
		padding: 36px 32px 32px;
		transition: all 0.3s ease;
	}

	/* ===== 用户头部 ===== */
	.user-header {
		display: flex;
		align-items: center;
		gap: 16px;
		margin-bottom: 28px;
	}

	.avatar-wrapper {
		position: relative;
		flex-shrink: 0;
	}

	.avatar {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		background: linear-gradient(135deg, #00d4ff, #7b2ffc);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		font-weight: 600;
		color: #fff;
		text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
		box-shadow: 0 0 30px rgba(0, 212, 255, 0.2);
	}

	.status-dot {
		position: absolute;
		bottom: 2px;
		right: 2px;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		border: 2px solid rgba(10, 14, 26, 0.8);
		background: #4a5568;
		transition: all 0.4s ease;
	}

	.status-dot.active {
		background: #48bb78;
		box-shadow: 0 0 20px #48bb78;
	}

	.user-meta {
		flex: 1;
		min-width: 0;
	}

	.greeting {
		margin: 0;
		font-size: 22px;
		font-weight: 600;
		color: #ffffff;
		letter-spacing: -0.3px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px;
	}

	.role-badge {
		display: inline-block;
		font-size: 12px;
		font-weight: 500;
		padding: 2px 12px;
		border-radius: 40px;
		background: rgba(0, 212, 255, 0.15);
		color: #90e0ff;
		border: 1px solid rgba(0, 212, 255, 0.2);
	}

	.platform-sub {
		margin: 4px 0 0;
		font-size: 13px;
		color: rgba(255, 255, 255, 0.5);
	}

	.highlight-text {
		color: #90e0ff;
		font-weight: 500;
	}

	/* ===== 状态卡片 ===== */
	.status-section {
		margin-bottom: 24px;
	}

	.status-card {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 14px 20px;
		border-radius: 20px;
		background: rgba(255, 255, 255, 0.04);
		border: 1px solid rgba(255, 255, 255, 0.06);
		transition: all 0.3s ease;
	}

	.status-card.registered {
		border-color: rgba(72, 187, 120, 0.3);
		background: rgba(72, 187, 120, 0.08);
	}

	.status-card.unregistered {
		border-color: rgba(237, 137, 54, 0.3);
		background: rgba(237, 137, 54, 0.08);
	}

	.status-icon {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		font-weight: 700;
		flex-shrink: 0;
	}

	.registered .status-icon {
		background: rgba(72, 187, 120, 0.2);
		color: #48bb78;
	}

	.unregistered .status-icon {
		background: rgba(237, 137, 54, 0.2);
		color: #ed8936;
	}

	.status-text {
		display: flex;
		flex-direction: column;
	}

	.status-title {
		font-size: 15px;
		font-weight: 600;
		color: #ffffff;
		line-height: 1.4;
	}

	.status-desc {
		font-size: 12px;
		color: rgba(255, 255, 255, 0.5);
	}

	/* ===== 二维码引导 ===== */
	.qr-guide {
		background: rgba(255, 255, 255, 0.03);
		border-radius: 28px;
		padding: 24px 16px 18px;
		margin-bottom: 24px;
		text-align: center;
		border: 1px solid rgba(255, 255, 255, 0.04);
		animation: fadeInUp 0.5s ease;
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.qr-wrapper {
		display: inline-block;
		position: relative;
	}

	.scan-frame {
		position: relative;
		padding: 8px;
		background: rgba(0, 0, 0, 0.4);
		border-radius: 20px;
		border: 1px solid rgba(0, 212, 255, 0.2);
		box-shadow: 0 0 40px rgba(0, 212, 255, 0.05);
	}

	.scan-frame:hover {
		border-color: rgba(0, 212, 255, 0.6);
	}

	.qr-image {
		display: block;
		width: 160px;
		height: 160px;
		border-radius: 12px;
		background: #fff;
	}

	.scan-line {
		position: absolute;
		left: 12px;
		right: 12px;
		height: 2px;
		background: linear-gradient(90deg, transparent, #00d4ff, transparent);
		top: 20%;
		opacity: 0.6;
		animation: scanMove 2.5s infinite linear;
		box-shadow: 0 0 20px #00d4ff;
		pointer-events: none;
	}

	@keyframes scanMove {
		0% {
			top: 10%;
			opacity: 0.2;
		}

		50% {
			top: 80%;
			opacity: 0.8;
		}

		100% {
			top: 10%;
			opacity: 0.2;
		}
	}

	.qr-label {
		margin-top: 12px;
		font-size: 13px;
		font-weight: 500;
		color: rgba(255, 255, 255, 0.7);
	}

	.label-icon {
		margin-right: 6px;
	}

	.guide-tip {
		margin: 12px 0 0;
		font-size: 13px;
		color: rgba(255, 255, 255, 0.35);
		line-height: 1.6;
	}

	.light-text {
		color: rgba(255, 255, 255, 0.5);
	}

	/* ===== 底部双按钮布局 ===== */
	.action-area {
		text-align: center;
	}

	.button-group {
		display: flex;
		gap: 12px;
		width: 100%;
	}

	.button-group .btn-primary {
		flex: 1;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		padding: 14px 12px;
		border-radius: 80px;
		font-size: 15px;
		font-weight: 600;
		color: #ffffff;
		text-decoration: none;
		box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2);
		transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
		cursor: pointer;
		position: relative;
		overflow: hidden;
		min-height: 54px;
		text-align: center;
		line-height: 1.2;
	}

	.button-group .btn-primary::before {
		content: '';
		position: absolute;
		top: -50%;
		left: -60%;
		width: 200%;
		height: 200%;
		background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
		transform: rotate(25deg);
		transition: all 0.5s;
	}

	.button-group .btn-primary:hover {
		transform: translateY(-3px) scale(1.02);
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
	}

	.button-group .btn-primary:hover::before {
		left: 60%;
	}

	.button-group .btn-arrow {
		transition: transform 0.3s ease;
		flex-shrink: 0;
	}

	.button-group .btn-primary:hover .btn-arrow {
		transform: translateX(4px);
	}

	/* 两个按钮不同配色 */
	.btn-class {
		background: linear-gradient(135deg, #00d4ff, #7b2ffc);
	}

	.btn-contest {
		background: linear-gradient(135deg, #48bb78, #38a169);
	}

	.btn-sub {
		margin-top: 14px;
		font-size: 12px;
		color: rgba(255, 255, 255, 0.3);
		letter-spacing: 0.5px;
	}


	@media (max-width: 380px) {
		.glass-card {
			padding: 18px 12px;
		}

		.user-header {
			gap: 12px;
		}

		.greeting {
			font-size: 16px;
		}

		.button-group .btn-primary {
			font-size: 13px;
			padding: 10px 12px;
			min-height: 42px;
		}
	}

	@media (min-width: 1024px) {
		.portal-container {
			padding: 40px;
			background: #080c18;
		}

		.glass-card {
			padding: 44px 40px 36px;
			transition: transform 0.4s;
		}

		.glass-card:hover {
			transform: scale(1.01);
		}

		.button-group .btn-primary {
			font-size: 16px;
			padding: 16px 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/zhuowanguser.vue